import { VpIcon } from '@vtmn-play/react'
import { HTMLAttributes } from 'react'

type CategoryItemProps = {
  label: string
  selected: boolean
  onClick?: () => void
} & HTMLAttributes<HTMLLIElement>

export const SearchItem = ({ label, selected, onClick, ...htmlProps }: CategoryItemProps) => {
  const selectedIcon = selected ? <VpIcon name={'check'} color="var(--primary-blue)" /> : <></>

  return (
    <li {...htmlProps} className="w-full list-none">
      <button
        onClick={onClick}
        className={`w-full flex justify-between items-center py-5 text-base text-gray-900`}
      >
        {label}
        {selectedIcon}
      </button>
    </li>
  )
}
